import React, { FC, ReactNode } from 'react'
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material'
import type { SystemStyleObject, Theme } from '@mui/system'

import { colorTokens } from '@/apps/latest/shared/styles/colorTokens'

// Notion 流 table primitive. MUI Table の thin wrap.
// header: 12/600/secondary uppercase letter-spacing tight.
// row: 14/400/primary, py:1, hover-only bg.
// border: hairline (colorTokens.border.subtle) bottom only (= no outer Card).
export interface DataTableColumn {
  key: string
  label: ReactNode
  /** cell の右寄せ / 中央寄せ等. */
  align?: 'left' | 'center' | 'right'
  /** header cell の sx (= sort icon 等). */
  headerSx?: SystemStyleObject<Theme>
  /** header click handler (= sort 切替). */
  onHeaderClick?: () => void
}

interface DataTableProps {
  columns: DataTableColumn[]
  children: ReactNode
}

export const DataTable: FC<DataTableProps> = ({ columns, children }) => (
  <Box
    sx={{
      '& .MuiTableCell-root': {
        borderBottomColor: colorTokens.border.subtle,
        py: 1,
        px: 1.5,
        fontSize: 14,
        color: 'text.primary',
      },
      '& .MuiTableHead-root .MuiTableCell-root': {
        fontSize: 12,
        fontWeight: 500,
        color: 'text.secondary',
        py: 1,
        backgroundColor: 'transparent',
      },
      '& .MuiTableBody-root .MuiTableRow-root:hover': {
        backgroundColor: colorTokens.overlay.hover,
      },
    }}
  >
    <Table size="small">
      <TableHead>
        <TableRow>
          {columns.map((c) => (
            <TableCell
              key={c.key}
              align={c.align ?? 'left'}
              onClick={c.onHeaderClick}
              sx={[
                c.onHeaderClick ? { cursor: 'pointer' } : {},
                c.headerSx ?? {},
              ]}
            >
              {c.label}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>{children}</TableBody>
    </Table>
  </Box>
)
